<ng-container>
  <ng-container *ngIf="!isMaskedValue; else maskedInput">
    <miq-year-picker
      id="year-picker"
      [date]="fc.value"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [customClass]="{ failed: !!warning || !validSnapshot, 'mt-year-input': true }"
      [readonly]="readonly"
      [required]="required"
      [showClearIcon]="showClearIcon"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [ngClass]="{ 'miq-year-picker-readonly': readonly }"
      (selectionChange)="onSelectionChange($event)"
      (clearIcon)="onSelectionChange($event)"
    ></miq-year-picker>
  </ng-container>

  <ng-template #maskedInput>
    <mat-form-field appearance="outline" class="mt-year-input" [ngClass]="{ failed: !!warning || !validSnapshot }">
      <input matInput autocomplete="new-password" type="password" disabled [placeholder]="placeholder" [value]="date" />
    </mat-form-field>
  </ng-template>
</ng-container>
